export default __webpack_public_path__ + "39a50c3a8c5c09a517c9eca3db20fa72.webp";